import { create } from 'zustand'
import { PostType } from '../types/postType'
import { postTypeService } from '../services/postTypeService'

interface PostTypeState {
  postTypes: PostType[]
  loading: boolean
  error: string | null

  // Actions
  loadPostTypes: (platformId?: number) => Promise<void>
  reset: () => void
}

export const usePostTypeStore = create<PostTypeState>((set) => ({
  postTypes: [],
  loading: false,
  error: null,

  loadPostTypes: async (platformId?: number) => {
    set({ loading: true, error: null })
    try {
      const postTypes = await postTypeService.getPostTypes(platformId)
      set({ postTypes, loading: false })
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to load post types'
      set({ error: errorMessage, loading: false })
    }
  },

  reset: () => {
    set({
      postTypes: [],
      loading: false,
      error: null
    })
  }
}))
